import React from 'react';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';
import { useTimer } from '../../context/TimerContext';

const icons = {
  error: <AlertCircle className="w-5 h-5 text-red-500" />,
  success: <CheckCircle className="w-5 h-5 text-green-500" />,
  info: <Info className="w-5 h-5 text-blue-500" />,
};

export function Toast() {
  const { notification } = useTimer();

  if (!notification || !notification.isOpen) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 flex items-center space-x-3 animate-fade-in">
        {icons[notification.type]}
        <p className="text-gray-900 dark:text-white">{notification.message}</p>
      </div>
    </div>
  );
}